// 宮崎県イベント・祭りクイズ - 10問1セット×10セット

import { quizData } from './quizData';

export const quizSets = [
  {
    id: 1,
    title: "セット1: 神話と伝説 (前半)",
    category: "神話と伝説",
    questions: quizData.slice(0, 10)
  },
  {
    id: 2,
    title: "セット2: 神話と伝説 (後半) & 時代を巡る行列 (前半)",
    category: "神話と伝説・時代を巡る行列",
    questions: quizData.slice(10, 20)
  },
  {
    id: 3,
    title: "セット3: 時代を巡る行列 (中盤)",
    category: "時代を巡る行列",
    questions: quizData.slice(20, 30)
  },
  {
    id: 4,
    title: "セット4: 炎の祭典 (前半)",
    category: "炎の祭典",
    questions: quizData.slice(30, 40)
  },
  {
    id: 5,
    title: "セット5: 炎の祭典 (後半) & 四季の恵み (前半)",
    category: "炎の祭典・四季の恵み",
    questions: quizData.slice(40, 50)
  },
  {
    id: 6,
    title: "セット6: 四季の恵み (中盤)",
    category: "四季の恵み",
    questions: quizData.slice(50, 60)
  },
  {
    id: 7,
    title: "セット7: 四季の恵み (後半) & 現代の賑わい (前半)",
    category: "四季の恵み・現代の賑わい",
    questions: quizData.slice(60, 70)
  },
  {
    id: 8,
    title: "セット8: 現代の賑わい (後半) & 固有の伝統 (前半)",
    category: "現代の賑わい・固有の伝統",
    questions: quizData.slice(70, 80)
  },
  {
    id: 9,
    title: "セット9: 固有の伝統 (後半) & 総合問題 (前半)",
    category: "固有の伝統・総合問題",
    questions: quizData.slice(80, 90)
  },
  {
    id: 10,
    title: "セット10: 総合問題 (後半)",
    category: "総合問題",
    questions: quizData.slice(90, 100)
  }
];

// 全クイズデータを1つの配列にまとめたもの（既存のコードとの互換性のため）
export const allQuizData = quizSets.flatMap(set => set.questions);
